import { useEffect } from 'react';

import { processFindingMethod } from '@libs/analytics';

import { dataLayerPush } from '@/shared/analytics';

export const usePdpFindMethod = () => {
    useEffect(() => {
        dataLayerPush({
            event: 'pdpFindMethod',
            findingMethod: processFindingMethod(window.sessionStorage.pdpFindingMethod),
        });
    }, []);
};
